import React from "react";
var LoadingFaceTec = function () {
    return (React.createElement("div", { className: "loading-button" },
        React.createElement("div", { className: "spinner" })));
};
export default LoadingFaceTec;
